/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

const successDismissDelayMs = 5000;

let domContentLoadedBound = false;

function focusSignupMessageRegions() {
  const messageRegions = document.querySelectorAll('[data-email-signup-message-focus]');

  if (messageRegions.length === 0) return;

  for (const messageRegion of messageRegions) {
    if (messageRegion instanceof HTMLElement) {
      messageRegion.focus({ preventScroll: true });

      if (messageRegion.classList.contains('email-signup__message--success')) {
        setTimeout(() => {
          messageRegion.classList.add('email-signup__message--dismissed');
          messageRegion.removeAttribute('data-email-signup-message-focus');
        }, successDismissDelayMs);
      }
    }
  }
}

function initEmailSignupMessages() {
  if (document.readyState === 'loading') {
    if (!domContentLoadedBound) {
      domContentLoadedBound = true;
      document.addEventListener('DOMContentLoaded', focusSignupMessageRegions, { once: true });
    }
  } else {
    queueMicrotask(focusSignupMessageRegions);
  }
}

initEmailSignupMessages();
